// extracted by mini-css-extract-plugin
export default {"addjsblog":"addjsblog_d704efa400da997e125d"};